import user from "./user";
import counsel from "./counsel";
import lecture from "./lecture";
import beauty from "./beauty";
import review from "./review";
import b4a from "./b4a";

export default { user, counsel, lecture, beauty, review, b4a };
